'use strict';

exports.__esModule = true;

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _objectHash = require('object-hash');

var _objectHash2 = _interopRequireDefault(_objectHash);

var _client = require('@swarm/client');

var _client2 = _interopRequireDefault(_client);

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

var _rdt = require('@swarm/rdt');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var API = function () {
  function API(options) {
    _classCallCheck(this, API);

    this.client = new _client2.default(options);
    this.options = options;
    this.subs = [];
    this.cache = {};
    if (options.gcPeriod) {
      this.gcInterval = setInterval(this.gc.bind(this), options.gcPeriod);
    }
    // $FlowFixMe
    this.uuid = this.uuid.bind(this);
    return this;
  }

  API.prototype.ensure = function ensure() {
    return this.client.ensure();
  };

  API.prototype.uuid = function uuid() {
    if (!this.client.clock) throw new Error('have no clock yet, invoke `await <swarm>.ensure()` first');
    return this.client.clock.time();
  };

  // garbage collection for unused cached data


  API.prototype.gc = function gc() {
    var ret = { deleted: 0, existing: 0 };
    var lstnrs = {};
    for (var _iterator = Object.keys(this.client.lstn), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var id = _ref;
      lstnrs[id] = true;
    }for (var _iterator2 = Object.keys(this.cache), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var _id = _ref2;

      if (!lstnrs[_id]) {
        delete this.cache[_id];
        ret.deleted++;
      } else {
        ret.existing++;
      }
    }

    return ret;
  };

  API.prototype.set = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee(id, value) {
      var uuid, type, frame, _iterator3, _isArray3, _i3, _ref4, k, op;

      return _regeneratorRuntime2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (id) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', false);

            case 2:
              uuid = id instanceof _ron.UUID ? id : _ron.UUID.fromString(id);
              _context.next = 5;
              return this.client.ensure();

            case 5:
              if (!this.options.strictMode) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return this.typeOf(id);

            case 8:
              type = _context.sent;

              if (!(type && type !== _rdt.lww.type.toString())) {
                _context.next = 11;
                break;
              }

              return _context.abrupt('return', false);

            case 11:
              frame = new _ron.Frame();


              frame.push(new _ron2.default(_rdt.lww.type, uuid, this.uuid(), _ronUuid.ZERO, undefined, _ron.FRAME_SEP));

              _iterator3 = Object.keys(value).sort(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();

            case 14:
              if (!_isArray3) {
                _context.next = 20;
                break;
              }

              if (!(_i3 >= _iterator3.length)) {
                _context.next = 17;
                break;
              }

              return _context.abrupt('break', 33);

            case 17:
              _ref4 = _iterator3[_i3++];
              _context.next = 24;
              break;

            case 20:
              _i3 = _iterator3.next();

              if (!_i3.done) {
                _context.next = 23;
                break;
              }

              return _context.abrupt('break', 33);

            case 23:
              _ref4 = _i3.value;

            case 24:
              k = _ref4;
              op = new _ron2.default(_rdt.lww.type, uuid, frame.last.uuid(2), _ron.UUID.fromString(k), undefined, ',');

              if (!(value[k] !== undefined)) {
                _context.next = 30;
                break;
              }

              op.values = (0, _ron.js2ron)([value[k]]);

              if (!(!uuid.isLocal() && value[k] instanceof _ron.UUID && value[k].isLocal())) {
                _context.next = 30;
                break;
              }

              return _context.abrupt('return', false);

            case 30:

              frame.push(op);

            case 31:
              _context.next = 14;
              break;

            case 33:
              if (!frame.isPayload()) {
                _context.next = 37;
                break;
              }

              _context.next = 36;
              return this.client.push(frame.toString());

            case 36:
              return _context.abrupt('return', true);

            case 37:
              return _context.abrupt('return', false);

            case 38:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function set(_x, _x2) {
      return _ref3.apply(this, arguments);
    }

    return set;
  }();

  API.prototype.add = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee2(id, value) {
      var uuid, type, frame, time, op;
      return _regeneratorRuntime2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (id) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return', false);

            case 2:
              uuid = id instanceof _ron.UUID ? id : _ron.UUID.fromString(id);
              _context2.next = 5;
              return this.client.ensure();

            case 5:
              if (!this.options.strictMode) {
                _context2.next = 11;
                break;
              }

              _context2.next = 8;
              return this.typeOf(id);

            case 8:
              type = _context2.sent;

              if (!(type && type !== _rdt.set.type.toString())) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt('return', false);

            case 11:
              frame = new _ron.Frame();
              time = this.uuid();
              op = new _ron2.default(_rdt.set.type, uuid, time, _ronUuid.ZERO, undefined, _ron.FRAME_SEP);

              frame.push(op);
              op = op.clone();

              if (!(!uuid.isLocal() && value instanceof _ron.UUID && value.isLocal())) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt('return', false);

            case 18:

              op.values = (0, _ron.js2ron)([value]);
              frame.pushWithTerm(op, ',');

              _context2.next = 22;
              return this.client.push(frame.toString());

            case 22:
              return _context2.abrupt('return', true);

            case 23:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function add(_x3, _x4) {
      return _ref5.apply(this, arguments);
    }

    return add;
  }();

  API.prototype.remove = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee3(id, value) {
      var uuid, type, frame, ts, deleted, op, state, str, _iterator4, _isArray4, _i4, _ref7, v;

      return _regeneratorRuntime2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (id) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt('return', false);

            case 2:
              uuid = id instanceof _ron.UUID ? id : _ron.UUID.fromString(id);

              id = uuid.toString();
              _context3.next = 6;
              return this.client.ensure();

            case 6:
              if (!this.options.strictMode) {
                _context3.next = 12;
                break;
              }

              _context3.next = 9;
              return this.typeOf(id);

            case 9:
              type = _context3.sent;

              if (!(type !== _rdt.set.type.toString())) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt('return', false);

            case 12:
              frame = new _ron.Frame();
              ts = this.uuid();
              deleted = false;
              op = new _ron2.default(_rdt.set.type, uuid, ts, _ronUuid.ZERO, undefined, _ron.FRAME_SEP);

              frame.push(op);

              _context3.next = 19;
              return this.client.storage.get(id);

            case 19:
              state = _context3.sent;

              if (state) {
                _context3.next = 22;
                break;
              }

              return _context3.abrupt('return', false);

            case 22:
              str = (0, _ron.js2ron)([value]);
              _iterator4 = new _ron.Frame(state), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();

            case 24:
              if (!_isArray4) {
                _context3.next = 30;
                break;
              }

              if (!(_i4 >= _iterator4.length)) {
                _context3.next = 27;
                break;
              }

              return _context3.abrupt('break', 40);

            case 27:
              _ref7 = _iterator4[_i4++];
              _context3.next = 34;
              break;

            case 30:
              _i4 = _iterator4.next();

              if (!_i4.done) {
                _context3.next = 33;
                break;
              }

              return _context3.abrupt('break', 40);

            case 33:
              _ref7 = _i4.value;

            case 34:
              v = _ref7;

              if (v.isRegular()) {
                _context3.next = 37;
                break;
              }

              return _context3.abrupt('continue', 38);

            case 37:
              if (v.values === str) {
                deleted = true;
                op = op.clone();
                op.location = v.event;
                op.values = '';
                frame.pushWithTerm(op, ',');
              }

            case 38:
              _context3.next = 24;
              break;

            case 40:
              if (!deleted) {
                _context3.next = 43;
                break;
              }

              _context3.next = 43;
              return this.client.push(frame.toString());

            case 43:
              return _context3.abrupt('return', deleted);

            case 44:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function remove(_x5, _x6) {
      return _ref6.apply(this, arguments);
    }

    return remove;
  }();

  API.prototype.close = function close() {
    return this.client.close();
  };

  API.prototype.open = function open() {
    return this.client.open();
  };

  API.prototype.typeOf = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee4(id) {
      var obj, state, op;
      return _regeneratorRuntime2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              obj = this.cache[id.toString()];

              if (!(obj !== undefined)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt('return', obj && obj.type && typeof obj.type === 'string' ? obj.type : '');

            case 3:
              _context4.next = 5;
              return this.client.storage.get(id.toString());

            case 5:
              state = _context4.sent;

              if (!state) {
                _context4.next = 10;
                break;
              }

              op = _ron2.default.fromString(state);

              if (!op) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt('return', op.uuid(0).toString());

            case 10:
              return _context4.abrupt('return', null);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function typeOf(_x7) {
      return _ref8.apply(this, arguments);
    }

    return typeOf;
  }();

  return API;
}();

exports.default = API;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/api/lib/index.js
// module id = 40
// module chunks = 0